<template>
  <header
    class="bg-white shadow h-6 flex min-w-full items-center sticky top-0 z-80"
    :style="{ width: daysInTotalWeeks.length * 32 + 160 + 'px' }"
  >
    <div class="w-40 flex-shrink-0"></div>
    <div
      v-for="(day, $i) in daysInTotalWeeks"
      :key="$i"
      class="relative flex-shrink-0 h-full flex items-center justify-center uppercase type-scale-n5 font-medium w-8"
      :class="[day === 'sö' && 'text-red-40', day === 'lö' && 'text-gray-40']"
    >
      {{ day.substring(0, 1) }}
      <div
        v-if="day === 'sö'"
        :class="$style.weekBorder"
        :style="{ height: months.length * 32 + 24 + 'px' }"
      ></div>
    </div>
  </header>
</template>

<script>
import { get } from 'vuex-pathify'

const week = ['må', 'ti', 'on', 'to', 'fr', 'lö', 'sö']

export default {
  name: 'TimetableTimeline',

  computed: {
    months: get('timetable/months'),

    daysInTotalWeeks() {
      return [...week, ...week, ...week, ...week, ...week, ...week.slice(0, 2)]
    }
  }
}
</script>

<style lang="postcss" module>
.weekBorder {
  width: 1px;
  @apply absolute top-0 right-0 h-screen bg-blue-30 opacity-25 pointer-events-none;
}
</style>
